export const DATA_API_REQUEST = 'DATA_API_REQUEST';
export const DATA_API_SUCCESS = 'DATA_API_SUCCESS';
export const DATA_API_FAILURE = 'DATA_API_FAILURE';
export const DATA_DELETE = 'DATA_DELETE';
export const DATA_CLEAR_RELATIONSHIP = 'DATA_CLEAR_RELATIONSHIP';
export const DATA_REMOVE_RELATIONSHIP = 'DATA_REMOVE_RELATIONSHIP';
